import { SVGAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

export function ChevronUp({ width = 24, height = 24, className, ...rest }: SVGAttributes<SVGElement>) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      {...rest}
      className={twMerge('', className)}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.47 8.47a.75.75 0 011.06 0l6 6a.75.75 0 11-1.06 1.06L12 10.06l-5.47 5.47a.75.75 0 01-1.06-1.06l6-6z"
        fill="#22282F"
      />
    </svg>
  );
}
